import React, { useState, useEffect } from "react";
import Hqtitle from "../hqdashboard/Hqtitle";
import Hqskip from "../hqdashboard/Hqskip";
import Hqaddress from "../hqdashboard/Hqaddress";
import arrowleft from '../../assets/images/arrowleft.png'; 
import arrowright from '../../assets/images/arrowright.png'; 

function Hq() {

useEffect(() => {
    // Add the class to the body
    document.body.classList.add("hqheaderfooterremove"); 

    // Cleanup function to remove the class when the component is unmounted
    return () => {
      document.body.classList.remove("hqheaderfooterremove");
    };
  }, []);

  const items = Array(45).fill(null); // Example: 40 items

  // Define a state for items per page that will change based on screen width
  const [itemsPerPage, setItemsPerPage] = useState(15);

  // Dynamically adjust itemsPerPage based on window width
  const updateItemsPerPage = () => {
    const width = window.innerWidth;

    if (width >= 2560) {
      setItemsPerPage(27); // Ultra-Wide Full HD
    } else if (width >= 1920) {
      setItemsPerPage(24); // Full HD
    } else if (width >= 1600) {
      setItemsPerPage(20); // HD+ or similar
    } else if (width >= 1440) {
      setItemsPerPage(18); // QHD
    } else if (width >= 1366) {
      setItemsPerPage(15); // HD+ (16:9)
    } else if (width >= 1280) {
      setItemsPerPage(12); // Lower HD
    } else if (width >= 768) {
      setItemsPerPage(10); // Tablet
    } else {
      setItemsPerPage(4); // Mobile
    }

  };

  // Effect hook to adjust the number of items per page on window resize
  useEffect(() => {
    updateItemsPerPage(); // Set items per page initially
    window.addEventListener('resize', updateItemsPerPage); // Listen to window resize

    // Cleanup the event listener
    return () => {
      window.removeEventListener('resize', updateItemsPerPage);
    };
  }, []);

  // Group items into pages based on itemsPerPage
  const pages = [];
  for (let i = 0; i < items.length; i += itemsPerPage) {
    const group = i === 0 
      ? [<Hqskip key="skip" />, ...Array(Math.min(itemsPerPage - 1, items.length - i)).fill(null).map((_, idx) => <Hqaddress key={`address-${i + idx}`} />)]
      : Array(Math.min(itemsPerPage, items.length - i)).fill(null).map((_, idx) => <Hqaddress key={`address-${i + idx}`} />);
    pages.push(group);
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => prevIndex + 1);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + pages.length) % pages.length);
  };

  const slideStyle = {
    transform: `translateX(-${currentIndex * 100}%)`,
    transition: "transform 0.5s ease-in-out",
  };

  // Check if next button should be disabled
  const isNextDisabled = currentIndex >= pages.length - 1;
  const isPrevDisabled = currentIndex <= 0;

  return (
    <div className="hqdashboard">
      <Hqtitle />
      <div className="innerwrapper">
        <div className="hqslider">
          <button
            className="nav-button left"
            onClick={handlePrev}
            disabled={isPrevDisabled} >
            <img src={arrowleft} alt="Left Arrow" />
          </button>
          <div className="hqslide-wrapper">
            <div className="hqslide" style={slideStyle}>
              {pages.map((page, pageIndex) => (
                <div key={`page-${pageIndex}`} className="hqslide-page">
                  {page}
                </div>
              ))}
            </div>
          </div>
          <button
            className="nav-button right"
            onClick={handleNext}
            disabled={isNextDisabled} >
            <img src={arrowright} alt="Right Arrow" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Hq;
